/**
 * Clinical-acceptability rule for the lesser-trochanter neck-resection distance.
 *
 * Separate from the geometry in `ltResectionDistance.ts`: that module computes the signed
 * distance, this one decides whether that distance warrants a surgeon-facing warning.
 */

/** Minimum clinically-acceptable neck-resection distance above the lesser trochanter, in mm. */
export const MIN_LT_RESECTION_DISTANCE_MM = 5;

/**
 * True when the neck cut is less than the minimum acceptable distance (5mm,
 * `MIN_LT_RESECTION_DISTANCE_MM`) above the lesser trochanter.
 *
 * The distance is signed (see `calculateLtResectionDistance`): a negative value means the
 * resection plane is inferior to the LT landmark, which is always below the minimum.
 */
export function isLtResectionBelowMinimum(distance: number): boolean {
    return distance < MIN_LT_RESECTION_DISTANCE_MM;
}